import { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';

import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import MobileDeviceAndConnectivity from './MobileDeviceAndConnectivity';

import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  countries: string[];
  familyType: CampaignFamilyEnum;
  onChange: (targeting: TargetingBaseType) => void;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function MobileDeviceAndConnectivityWrapper({ countries, familyType, onChange, targeting, user, userRoles }: Props) {
  return (
    <TargetingProvider
      countries={countries}
      familyType={familyType}
      onChange={onChange}
      targeting={targeting}
      user={user}
      userRoles={userRoles}
    >
      <MobileDeviceAndConnectivity />
    </TargetingProvider>
  );
}

export default MobileDeviceAndConnectivityWrapper;
